import React, { Component } from 'react';
import "./style.less";
import { Icon } from 'antd';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button } from 'antd';

const FALSE = 'false';

class MyInvite extends Component{  
  constructor() {
    super();
    this.state = {
      copied: "false",
    };
  }
  handleCopyChange = () =>{
    this.setState({copied: "true"});
  };
  render() {
      return(
        
        <div className="content">
          <div className="title1">我的邀请码：</div>
          {this.props.myId ? <div><div className="title2">{this.props.myId}</div> 
          <CopyToClipboard text={this.props.myId} >
                {this.state.copied === FALSE ? 
                 <Button className="copyBtn" onClick = {this.handleCopyChange}>复制</Button> : 
                 <Button className="copyBtn" onClick = {this.handleCopyChange}>已复制</Button>}  
           </CopyToClipboard> </div> :
           <div className="title2"> 暂无邀请码</div>
          }
          <div className="title3">有效期至：{this.props.dueDate}</div>
          <Icon fill="yellow"type="exclamation-circle" />
          <div className="title4">用户在购买快站套餐时填写您的邀请码即为邀请成功</div>
        </div>
      );
  }
}
export default MyInvite;